import { Meta, Title } from '@angular/platform-browser';
import { Component } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { services } from '../../services';
import { TranslationService } from '../../../../../../shared/services/translations.service';
import { CookieService } from 'ngx-cookie-service';

@Component({
  selector: 'cs2-divisions',
  templateUrl: './cs2-premier-net-wins.component.html'
})
export class Cs2PremierNetWinsComponent {
  service = 'netwins';
  availableServices = services['cs2'].filter(service => service.service !== this.service);

  serviceParams = {
    game: 'cs2',
    service: 'netwins',
    type: 'solo',
    title: {
      en: 'Premier Net Wins',
    },
    queue: 'premier',
    subtitle: {
      en: "Secure your desired CS2 Premier Wins in any CS rating, Solo or Duo.",
      fr: "Obtenez vos victoires nettes désirées sur CS2 Premier dans n\'importe quel rang, en solo ou en duo.",
      de: "Sichere dir deine gewünschten CS2 Premier Wins in jeder CS-Bewertung, Solo oder Duo.",
      pt: "Garante vitórias em qualquer Rating para CS2 Premier, em Solo ou Duo Boosting.",
      es: "Consigue tu CS2 Premier Wins deseado en cualquier clasificación CS, Solo o Duo.",
    },
    serviceName: 'Wins',
    start: 5,
    min: 1,
    max: 5,
    desired: 5
  }

  serviceFaqs = {
    en: [
      {
        question: "What Is A CS Rating Net Win Boost?",
        answer: "A Net Win boost is the difference between the number of victories and losses. For each loss, you receive an additional win. ex: 2 Net Wins = 2W-0L or 3W-1L."
      },
      {
        question: "Can I Play With The Booster In Duo While Boosting?",
        answer: "Certainly, you have the option to do so. To make this happen, select the \"Duo\" option on the customization menu."
      },
      {
        question: "Can I Play While The Order Is Active?",
        answer: "Yes, you can play any game mode, except the rank mode of the service. Just pause the order and schedule it in the order chat with your booster."
      },
      {
        question: "Can I Modify My Order While It is Active?",
        answer: "Absolutely! Inform our live support about the changes you would like to make, and they will be more than happy to assist you in modifying your order according to your requirements."
      },
      {
        question: "Can I Request The Same Booster For A Future Purchase?",
        answer: "Yes! Click the heart icon inside the order dashboard to favorite a booster, then easily reassign them to your future orders."
      },
      {
        question: "What If I Have More Questions?",
        answer: "We have a dedicated Live Support Team, online 24 hours per day, always ready to help you through every step and ready to answer all your questions!"
      }
    ],
    fr: [
      {
        question: "Qu\'est-ce qu\'un Boost de victoire nette de rang sur CS?",
        answer: "Le boost de victoires nettes est la différence entre le nombre de victoires et de défaites. Pour chaque défaite, vous recevez une victoire supplémentaire. ex : 2 victoires nettes = 2V-0D ou 3V-1D."
      },
      {
        question: "Puis-je jouer en duo avec le booster pendant que je booste?",
        answer: "Certainement, vous avez la possibilité de le faire. Pour ce faire, sélectionnez l\'option \"Duo\" dans le menu de personnalisation."
      },
      {
        question: "Puis-je jouer pendant que la commande est active?",
        answer: "Oui, vous pouvez jouer dans n\'importe quel mode de jeu, à l\'exception du mode du service. Il suffit de mettre la commande en pause et de le programmer dans le chat de la commande avec votre booster."
      },
      {
        question: "Puis-je modifier ma commande pendant qu\'elle est active?",
        answer: "Absolument! Informez notre service d\'assistance en ligne des changements que vous souhaitez apporter, et ils seront ravis de vous aider à modifier votre commande en fonction de vos besoins."
      },
      {
        question: "Puis-je demander le même booster pour un prochain achat?",
        answer: "Oui ! Cliquez sur l\'icône en forme de cœur dans le tableau de bord de commande pour ajouter un booster en favori, puis réassignez-le facilement à vos prochaines commandes."
      },
      {
        question: "Et si j\'ai d\'autres questions?",
        answer: "Nous disposons d\'une équipe d\'assistance en ligne dédiée, disponible 24 heures sur 24, toujours prête à vous aider à chaque étape et à répondre à toutes vos questions!"
      }
    ],
    de: [
      {
        question: "Was ist ein CS Rating Net Win Boost?",
        answer: "Ein Net Win Boost ist die Differenz zwischen der Anzahl der Siege und der Anzahl der Niederlagen. Für jede Niederlage erhältst du einen zusätzlichen Sieg. z.B.: 2 Net Wins = 2W-0L oder 3W-1L."
      },
      {
        question: "Kann ich mit dem Booster im Duo spielen, während ich booste?",
        answer: "Natürlich! Dazu klickst du auf die Schaltfläche \"Duo\" im Menü der Bestellungszusätze "
      },
      {
        question: "Kann ich spielen, während die Bestellung aktiv ist?",
        answer: "Ja, es sei denn, du möchtest im gleichen Ranking-Modus wie der gekaufte Dienst spielen. Ansonsten planst du das mit deinem Booster im Auftragschat."
      },
      {
        question: "Kann ich meine Bestellung ändern, während sie aktiv ist?",
        answer: "Aber sicher! Teile unserem Live Support mit, welche Änderungen du vornehmen möchtest und er wird dir gerne bei der Anpassung deiner Bestellung nach deinen Wünschen behilflich sein."
      },
      {
        question: "Kann ich denselben Booster für zukünftige Käufe anfordern?",
        answer: "Ja! Klicke im Bestell-Dashboard auf das Herzsymbol, um einen Booster zu deinen Favoriten hinzuzufügen, und weise ihn dann ganz einfach zukünftigen Bestellungen zu."
      },
      {
        question: "Was ist, wenn ich noch mehr Fragen habe?",
        answer: "Mit unserem engagierten Live-Support-Team sind wir 24 Stunden am Tag online, um dir bei jedem Schritt zu helfen und alle deine Fragen zu beantworten!"
      }
    ],
    pt: [
      {
        question: "O Que É Um serviço de Net Win CS Rating Boost?",
        answer: "Um boost de net wins é a diferença entre o número de vitórias e derrotas. Para cada derrota, você recebe uma vitória adicional. Exemplo: 2 Net Wins = 2V-0D ou 3V-1D."
      },
      {
        question: "Posso Jogar Com O Booster Em Duo Queue?",
        answer: "Sim, podes. Para isso, vai até ao menu de personalização do pedido e seleciona \"Duo\" antes de clicar em \"Comprar Boost Agora\"."
      },
      {
        question: "Posso Jogar Enquanto O Serviço Está Activo?",
        answer: "Sim, podes jogar qualquer modo de jogo, exceto o modo de classificação do serviço. Basta colocar em pausa o pedido e agendar no chat do pedido com teu booster."
      },
      {
        question: "Posso modificar o meu pedido enquanto ele está ativo?",
        answer: "Absolutamente! Informa o nosso suporte ao vivo sobre as alterações que gostavas fazer, e eles ficarão felizes em ajudar a modificar o teu pedido de acordo com as tuas necessidades."
      },
      {
        question: "Posso pedir o mesmo booster para uma compra futura?",
        answer: "Sim! Clica no ícone de coração dentro do painel do pedido para marcar um booster como favorito e depois escolhe-o facilmente nos teus próximos pedidos."
      },
      {
        question: "E se eu tiver mais perguntas?",
        answer: "Temos uma equipa dedicada de suporte ao vivo, disponível 24 horas por dia, sempre pronta para ajudar em cada passo e responder a todas as tuas perguntas!"
      }
    ],
    es: [
      {
        question: "¿Qué es un CS Rating Net Win Boost?",
        answer: "Un Boost de Net Win es la diferencia entre el número de victorias y derrotas. Por cada derrota, recibes una victoria adicional. ej: 2 Net Wins = 2W-0L o 3W-1L."
      },
      {
        question: "¿Puedo jugar con el Booster In Duo mientras Boosting?",
        answer: "Desde luego, tienes la opción de hacerlo. Para ello, selecciona la opción \"Duo\" en el menú de personalización."
      },
      {
        question: "¿Puedo jugar mientras la orden está activa?",
        answer: "Sí, puedes jugar en cualquier modo de juego, excepto en el modo de rango del servicio. Solo tienes que pausar la orden y programarla en el chat de órdenes con tu booster."
      },
      {
        question: "¿Puedo modificar mi pedido mientras está activo?",
        answer: "Por supuesto. Informa a nuestro servicio de asistencia en directo de los cambios que deseas realizar y estarán encantados de ayudarte a modificar tu pedido según tus necesidades."
      },
      {
        question: "¿Puedo solicitar al mismo booster para una compra futura?",
        answer: "¡Sí! Haz clic en el ícono de corazón dentro del panel del pedido para añadir un booster a favoritos y así poder reasignarlo fácilmente en tus futuros pedidos."
      }  ,
      {
        question: "¿Y si tengo más preguntas?",
        answer: "Contamos con un equipo de asistencia en directo las 24 horas del día, siempre dispuesto a ayudarte en cada paso y a responder a todas tus preguntas."
      }
    ]
  }

  private page = {
    title: {
      en: "Counter Strike 2 | Premier Wins Boosting Services",
      fr: "Counter Strike 2 | Services de Boosting de Victoires Nettes",
      de: "Counter Strike 2 | Premier Wins Boosting Services",
      pt: "Counter Strike 2 | Serviços de Boosting Net Wins",
      es: "Counter Strike 2 | Servicio Boosting Premier Wins",
    },
    metaDescription: {
      en: "Get your Counter Strike 2 Competitive Wins with GGBoost. Opt for the Best and Safest Boosting Services, ensuring Top Tier Performance Every Match",
      fr: "Obtenez vos victoires compétitives sur Counter Strike 2 avec GGBoost. Optez pour les meilleurs services de boosting et les plus sûrs, garantissant des performances de haut niveau à chaque partie.",
      de: "Hol dir deine Counter Strike 2 Competitive Wins mit GGBoost. Entscheide dich für den besten und sichersten Boosting-Service, der dir garantiert, dass du in jedem Match die beste Leistung bringen kannst.",
      pt: "Obtém as tuas vitórias competitivas do Counter Strike 2 com GGBoost. Opta pelos melhores e mais seguros serviços de boost de net wins, garantindo desempenho de alto nível a cada partida",
      es: "Consigue tus victorias competitivas en Counter Strike 2 con GGBoost. Opta por los mejores y más seguros servicios de Boosting, garantizando un rendimiento de primer nivel en cada partida.",
    }
  }

  lang: string = 'en';

  constructor(meta: Meta, title: Title, private route: ActivatedRoute, private router: Router, private translationService: TranslationService, private cookie: CookieService) {
    this.route.params.subscribe(params => {
      if (Object.keys(params).length === 0) {
        const url = this.router.url.split('/');
        if (this.translationService.validLangs.includes(url[1])) {
          this.lang = url[1];
        } else {
          this.lang = this.cookie.get('gg-lang') || 'en';
        }
      } else {
        this.lang = params['lang'] || 'en';
      }

      title.setTitle(this.page.title[this.lang] || this.page.title['en']);
      meta.updateTag(
        {
          name: 'description',
          content: this.page.metaDescription[this.lang] || this.page.metaDescription['en']
        },
      );
    });
  }
}